import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = {
  border: "15px",
  align: "center",
  width: "100%",
  height: "100px",
  cellpadding: "15px",
  cellspacing: "0px"
}
const _hoisted_3 = ["colspan", "rowspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableInfo.dataJson, (row, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, cIndex) => {
            return (_openBlock(), _createElementBlock("td", {
              key: cIndex,
              colspan: col.colSpan,
              rowspan: col.rowSpan
            }, _toDisplayString(col.spanValue), 9, _hoisted_3))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}